const SUPPORTED_FORMATS = ["image/jpg", "image/jpeg", "image/gif", "image/png"];

enum CustomerType {
  Homeowner,
  Organization,
}

enum FileType {
  IMAGE = "image",
  VIDEO = "video",
  PDF = "pdf",
}

enum ProjectDetailTabs {
  REVISIONS_MEDIA = "revisions-media",
  CHAT_BOARD = "chat-board",
  FEEDBACK_REQUEST = "feedback-request",
  PROJECT_OVERVIEW = "project-overview",
  SUBMITTED_REQUEST = "submitted-request",
  COLLABORATORS = "collaborators",
}

export enum RevisionStatus {
  IN_PROGRESS = "in_progress",
  WAITING_FOR_CLIENT_RESPONSE = "waiting_for_client_response",
  IN_REVIEW = "in_review",
  COMPLETED = "completed",
}

export enum NotificationType {
  PROJECT_DESIGNER_ADDED = "project_designer_added",
}

export { SUPPORTED_FORMATS, CustomerType, FileType, ProjectDetailTabs };
